import { Menu } from 'lucide-react'
import { useAuthStore } from '../../stores/authStore'
import NotificationCenter from './NotificationCenter'
import UserMenu from './UserMenu'
import SiteSwitcher from './SiteSwitcher'

interface HeaderProps {
  onMenuToggle: () => void
}

export default function Header({ onMenuToggle }: HeaderProps) {
  const user = useAuthStore((s) => s.user)

  return (
    <header role="banner" className="h-14 bg-bg-sidebar border-b border-border flex items-center justify-between px-4 shrink-0">
      <div className="flex items-center gap-3">
        {/* Hamburger -- shown on mobile and tablet when sidebar is hidden/collapsed */}
        <button
          onClick={onMenuToggle}
          aria-label="Toggle navigation menu"
          className="p-2 rounded-lg hover:bg-bg-hover text-text-secondary hover:text-text-primary transition-colors lg:hidden"
        >
          <Menu size={20} />
        </button>

        {user?.org_name && (
          <span className="text-sm text-text-secondary hidden sm:inline">
            {user.org_name}
          </span>
        )}
        <SiteSwitcher />
      </div>

      <div className="flex items-center gap-1">
        <NotificationCenter />
        <UserMenu />
      </div>
    </header>
  )
}
